import React, { useState } from 'react';
import { Drawer, Input, Card, Row, Col, Image, Typography } from 'antd';
import PersonDetails from './PersonDetails'
import { prUrl } from '../config';
import { minioHost } from '../config';
import search from '../../images/Union.svg'
import Icon from "@ant-design/icons";

const { Title } = Typography;

const PersonListDrawer = (props) => {
    const [isPersonModalOpen, setIsPersonModalOpen] = useState(false)
    const [person, setPerson] = useState(null)
    const [active, setActive] = useState('')
    const handlePersonModalShow = () => {
        setIsPersonModalOpen(!isPersonModalOpen)
        setActive('')
    }
    const handleOnClick = (person, index) => {
        handlePersonModalShow()
        setPerson(person)
        setActive(index)
    }
    const searchIcon = () => (
        <Image src={search} preview={false} />
    )

    return (
        <React.Fragment>
            <Drawer
                className='listDrawer'
                // <Button onClick={props.handleAddModalShow}>+添加关注人物</Button>
                // <Row><Col ><Title level={5}>重要人物列表</Title></Col><Col offset={9}></Col></Row>
                title={<span className="drawerTitle">重要人物列表</span>}
                placement="left"
                closable={false}
                onClose={props.handlePersonDrawerShow}
                visible={props.isPersonDrawerShow}
                getContainer={false}
                width={'450'}>
                <div className="drawerSearch">
                    <Input placeholder="请输入筛选条件……" type="text" onKeyUp={props.handleFilter} />
                    <div className="drawerSearchIcon">
                        <Icon component={searchIcon} />
                    </div>
                </div>
                {
                    props.filteredPeople.map((person, index) =>
                        // <MarkerItem person={person} sendPersonShow={sendPersonShow}/>
                        <Card className={active === index ? 'drawer-list-item-active drawer-list-item' : 'drawer-list-item'} hoverable title={<Title level={5}>{person.cn_name}</Title>} style={{ width: 385, border: 'false', cursor: 'pointer' }} onClick={(e) => handleOnClick(person, index, e)}>
                            <Row align='middle' justify='center'>
                                <Col span={8}>
                                    {person.thumbImage ? <Image src={prUrl + person.thumbImage} preview={false} /> : ''}
                                    {/* {person.avatar ? <Image src={minioHost + person.avatar} preview={false} /> : ''} */}
                                </Col>
                                <Col span={14} offset={1}>
                                    <p>中文名：{person.cn_name}</p>
                                    <p>英文名：{person.en_name}</p>
                                    <p>职&nbsp;&nbsp;&nbsp;务：{person.occupation}</p>
                                    <p>党&nbsp;&nbsp;&nbsp;派：{person.party}</p>
                                </Col>
                            </Row>
                        </Card>
                    )
                }
            </Drawer>
            {
                isPersonModalOpen ?
                    <PersonDetails isModalOpen={isPersonModalOpen} person={person} handleModalShow={handlePersonModalShow} /> : ''
            }
        </React.Fragment>
    )
};

export default PersonListDrawer;